var _window_location_hostname,_window_location,_window;const DEV_MODE=typeof window!=="undefined"&&((_window=window)==null?void 0:(_window_location=_window.location)==null?void 0:(_window_location_hostname=_window_location.hostname)==null?void 0:_window_location_hostname.includes(".care-staging.vpsvc.com"));

export { DEV_MODE };
//# sourceMappingURL=general.js.map
